import { HStack, Stack, Text } from '@chakra-ui/react';

import { Confluence } from '@/client/components/icons/individual/Confluence';
import { GoogleDrive } from '@/client/components/icons/individual/GoogleDrive';
import { OneDrive } from '@/client/components/icons/individual/OneDrive';
import OutlineButton from '@/client/components/shared/buttons/OutlineButton';
import { useExpertsStore } from '../expertsStore';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NoExpertsDashboardPlaceholder() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setIsEditingExpert } = useExpertsStore();

  return (
    <Stack
      spacing={4}
      padding={8}
      backgroundColor="neutral.0"
      border="1px solid"
      borderColor="neutral.100"
      borderRadius="24px"
    >
      <HStack gap={4}>
        <GoogleDrive boxSize={6} />

        <OneDrive boxSize={8} />

        <Confluence boxSize={6} />
      </HStack>

      <Text fontSize="18px" fontWeight={600} color="baseBlack">
        {t('admin.aiAgent.dashboard.experts.noExperts.title')}
      </Text>

      <Text fontSize="16px" fontWeight={500} color="neutral.800" maxWidth="70%">
        {t('admin.aiAgent.dashboard.experts.noExperts.helpText')}
      </Text>

      <OutlineButton
        width="fit-content"
        onClick={() => {
          setIsEditingExpert(true);
          navigate('/admin/eddy/experts/details');
        }}
      >
        {t('admin.aiAgent.dashboard.experts.noExperts.buttonCopy')}
      </OutlineButton>
    </Stack>
  );
}
